/**
 * QuickBooks Desktop item values that can feed a text field on an Orderwerks Catalog Item.
 */
enum QBDItemSourceFieldEnum {
    FullName = "FullName",
    Name = "Name",
    ManufacturerPartNumber = "ManufacturerPartNumber",
    SalesDesc = "SalesDesc",
    PurchaseDesc = "PurchaseDesc",
    BarCodeValue = "BarCodeValue",
}

export default QBDItemSourceFieldEnum;
